import { fetchFactory } from 'isotope-client'

export const getMe = () => fetchFactory(`/utilisateurs/me`)
